import React from 'react';
import classNames from 'classnames/bind';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import styles from './OutletColumn.css';

const cx = classNames.bind(styles);

class OutletColumn extends React.Component {
  render() {
    const { outlet, shop } = this.props;

    if (shop.status !== 'ACTIVE') {
      return (
        <div className={styles['outlet-name-column']}>
          <div>
            {shop.channel === ONLINE_STORE_CHANNEL.FACEBOOK && (
              <span className={styles['outlet-name']}>{outlet.name}</span>
            )}
            <span className={cx([styles['outlet-status'], styles.incomplete])}>
              Incomplete
            </span>
          </div>
          <div className={styles['text-grey']}>Not Connected</div>
        </div>
      );
    }

    return (
      <div className={styles['outlet-name-column']}>
        <div>
          {shop.channel === ONLINE_STORE_CHANNEL.FACEBOOK && (
            <a
              href={shop.additional.facebook_page_link}
              className={styles['outlet-name']}
              target="_blank"
              title={shop.additional.facebook_page_name}
            >
              {shop.additional.facebook_page_name}
            </a>
          )}
          <span className={cx([styles['outlet-status'], styles.active])}>
            Active
          </span>
        </div>
        <div
          className={styles['outlet-address']}
          title={`${outlet.name} - ${outlet.city} - ${outlet.address}`}
        >
          <b>{outlet.name} &#9679;</b> {outlet.city} &bull; {outlet.address}
        </div>
      </div>
    );
  }
}

export default OutletColumn;
